module.exports = __webpack_public_path__ + "img/receipt-top-none.5090333d.jpg";